import React, { createContext, useState, useContext, useCallback, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const TeamContext = createContext();

export function TeamProvider({ children }) {
    const [teamMembers, setTeamMembers] = useState([]);
    const [lastFetch, setLastFetch] = useState(null);
    const [loading, setLoading] = useState(false);
    const { token } = useAuth();

    const CACHE_DURATION = 30000; // 30 seconds cache

    const fetchTeamMembers = useCallback(async (force = false) => {
        // If we have recent data and not forcing refresh, use cached data
        if (!force && lastFetch && (Date.now() - lastFetch) < CACHE_DURATION) {
            return teamMembers;
        }

        setLoading(true);
        try {
            const response = await axios.get('/api/team/members', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setTeamMembers(response.data);
            setLastFetch(Date.now());
            return response.data;
        } catch (error) {
            console.error('Error fetching team members:', error);
            return [];
        } finally {
            setLoading(false);
        }
    }, [token, lastFetch, teamMembers]);

    // Expose the context
    const value = {
        teamMembers,
        loading,
        fetchTeamMembers,
        refreshTeamMembers: () => fetchTeamMembers(true)
    };

    return (
        <TeamContext.Provider value={value}>
            {children}
        </TeamContext.Provider>
    );
}

export function useTeam() {
    return useContext(TeamContext);
} 